import { DateTime } from 'luxon'

export const DATE_WITH_WEEKDAY_FORMAT: Intl.DateTimeFormatOptions = {
  weekday: 'long',
  month: 'long',
  day: 'numeric',
}

export const TIME_WITH_TIMEZONE_SHORT_FORMAT: Intl.DateTimeFormatOptions = {
  ...DateTime.TIME_SIMPLE,
  timeZoneName: 'short',
}
